const loadingStrings = {
  en: {
    loading: "Loading...",
    pleaseWait: "Please wait while we process your request",
  },
  ar: {
    loading: "جارٍ التحميل...",
    pleaseWait: "يرجى الانتظار بينما نعالج طلبك",
  },
};

export default loadingStrings;
